import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminUsersService {

  serviceBaseURL: string = '';
  constructor(private http: HttpClient) {
    this.serviceBaseURL = environment.serviceBaseUrl;
  }


  getUsers(): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/GetAllUsers').toPromise();
  }

  addUsers(Users): Promise<any> {
    return this.http.post(this.serviceBaseURL + 'Kesavi/AddUsers', Users).toPromise();
  }

  editUsers(Users): Promise<any> {
    return this.http.post(this.serviceBaseURL + 'Kesavi/EditUsers', Users).toPromise();
  }

  deleteUsersByID(usersID): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/DeleteUsers/' + usersID).toPromise();
  }

  getLoginUsers(UserName, Password): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/UserLogin?UserName=' + UserName + "&Password=" + Password).toPromise();
  }

}
